module.exports = __webpack_public_path__ + "img/productivo.04b747bc.png";